"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var query_string_1 = __importDefault(require("query-string"));
var comic_1 = __importDefault(require("./comic"));
var loading_1 = __importDefault(require("../shared/loading"));
var episode_1 = __importDefault(require("../episode/episode"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var data_service_1 = __importDefault(require("../../services/data.service"));
var ComicRoot = (function (_super) {
    __extends(ComicRoot, _super);
    function ComicRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            comicWasFetched: false,
        };
        return _this;
    }
    ComicRoot.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var comicSlug, comic, langParamArray, langParam, comicLang;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        comicSlug = this.props.match.params.comicSlug;
                        return [4, data_service_1.default.getComicBySlug(comicSlug, true)];
                    case 1:
                        comic = _a.sent();
                        if (!comic) {
                            this.props.history.push('/404');
                        }
                        else {
                            langParamArray = query_string_1.default.parse(location.search).lang;
                            langParam = (Array.isArray(langParamArray) ? langParamArray[0] : langParamArray);
                            if (langParam && !comic.supportedLangs.includes(langParam))
                                this.props.history.push('/404');
                            comicLang = langParam || comic.defaultLang;
                            lang_service_1.default.setComicLang(comicLang);
                            this.setState({
                                comicWasFetched: true,
                            });
                        }
                        return [2];
                }
            });
        });
    };
    ComicRoot.prototype.render = function () {
        if (!this.state.comicWasFetched)
            return react_1.default.createElement(loading_1.default, null);
        return (react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/", component: comic_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/episodes/:episodeSlug/:pageNumber/languages/", component: episode_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/episodes/:episodeSlug/:pageNumber/comments/", component: episode_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/episodes/:episodeSlug/:pageNumber/episode-list/", component: episode_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/episodes/:episodeSlug/:pageNumber/", component: episode_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/:comicSlug/episodes/:episodeSlug/", component: function (_a) {
                    var location = _a.location;
                    var middleSlash = location.pathname.slice(-1) === '/' ? '' : '/';
                    var newLocation = __assign(__assign({}, location), { pathname: "".concat(location.pathname).concat(middleSlash, "1/") });
                    return react_1.default.createElement(react_router_dom_1.Redirect, { to: newLocation });
                } })));
    };
    return ComicRoot;
}(react_1.Component));
exports.default = ComicRoot;
